import { defineMessages } from 'react-intl'

export default defineMessages({
  home: {
    id: 'Header.menuBar.home',
    defaultMessage: 'Home',
  },
  features: {
    id: 'Header.menuBar.features',
    defaultMessage: 'Features',
  },
  blog: {
    id: 'Header.menuBar.blog',
    defaultMessage: 'Blog',
  },
  food: {
    id: 'Header.menuBar.food',
    defaultMessage: 'Food',
  },
  fitness: {
    id: 'Header.menuBar.fitness',
    defaultMessage: 'Fitness',
  },
  premium: {
    id: 'Header.menuBar.premium',
    defaultMessage: 'Premium',
  },
  account: {
    id: 'Header.menuBar.account',
    defaultMessage: 'Account',
  },
  logIn: {
    id: 'Header.menuBar.logIn',
    defaultMessage: 'Log in',
  },
  logOut: {
    id: 'Header.menuBar.logOut',
    defaultMessage: 'Log out',
  },
  signUp: {
    id: 'Header.menuBar.signUp',
    defaultMessage: 'Sign up',
  },
  menu: {
    id: 'Header.menuBar.menu',
    defaultMessage: 'Menu',
  },
  giftCard: {
    id: 'Header.menuBar.giftCard',
    defaultMessage: 'Give a gift',
  },
  install_now: {
    id: 'install_now',
    defaultMessage: 'Install now',
  },
})
